import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
    VStack,
    HStack,
    Text,
    Input,
    Button,
    Badge,
    Box,
    Divider,
} from '@chakra-ui/react';
import { useAppStore } from '../../state/store';
import { useWorksharingStore } from '../../state/useWorksharingStore';
import { ManageDialogFrame, ManageDialogPrimaryButton } from '../manage/ManageDialogFrame';

/**
 * Relinquish All Mine dialog (Collaborate > Synchronize panel).
 * Lists the worksets currently owned by the local user and releases them
 * back to the pool for the rest of the team.
 */
export function RelinquishDialog() {
    const { t } = useTranslation();
    const isOpen = useAppStore((state) => state.collabDialog === 'relinquish');
    const onClose = useAppStore((state) => state.closeCollabDialog);
    const worksets = useWorksharingStore((s) => s.worksets);
    const userName = useWorksharingStore((s) => s.userName);
    const setUserName = useWorksharingStore((s) => s.setUserName);
    const relinquishAllMine = useWorksharingStore((s) => s.relinquishAllMine);

    const owned = worksets.filter((w) =>w.owner === userName); const [editingName, setEditingName] = useState(false); return (<ManageDialogFrame
            title={t('collab.relinquishAllMine')}
            isOpen={isOpen}
            onClose={onClose}
            footer={
                <HStack spacing={2}>
                    <ManageDialogPrimaryButton
                        label={`Relinquish (${owned.length})`}
                        onClick={() => { relinquishAllMine(); }}
                        isDisabled={owned.length === 0}
                    />
                    <Button size="sm" variant="ghost" onClick={onClose}>{t('collab.close')}</Button>
                </HStack>
            }
        >
            <VStack spacing={3} align="stretch">
                <Text fontSize="xs" color="var(--color-text-secondary)">{t('collab.relinquishTheOwnershipOfWorksetsYouEditedButHaveNotReleasedOtherUse')}</Text>

                <HStack>
                    <Text fontSize="xs" color="var(--color-text-secondary)" flexShrink={0}>{t('collab.currentUser')}</Text>
                    {editingName ? (
                        <Input
                            size="xs"
                            defaultValue={userName}
                            autoFocus
                            bg="var(--color-bg-primary)"
                            borderColor="var(--color-border)"
                            maxW="260px"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    const v = (e.target as HTMLInputElement).value.trim();
                                    if (v) setUserName(v);
                                    setEditingName(false);
                                }
                            }}
                            onBlur={(e) => {
                                const v = e.target.value.trim();
                                if (v) setUserName(v);
                                setEditingName(false);
                            }}
                        />
                    ) : (
                        <Button size="xs" variant="ghost" onClick={() => setEditingName(true)}>{userName}</Button>
                    )}
                </HStack>

                <Divider />

                {owned.length === 0 ? (
                    <Text fontSize="sm" color="var(--color-text-secondary)">{t('collab.noWorksetsAreCurrentlyOwnedByYou')}</Text>
                ) : (
                    owned.map((ws) => (
                        <HStack key={ws.id} p={2} borderWidth="1px" borderColor="var(--color-border)" borderRadius="var(--cad-radius-sm)">
                            <Box flex="1 1 auto" minW={0}>
                                <Text fontSize="sm" isTruncated>{ws.name}</Text>
                            </Box>
                            <Badge colorScheme="blue" flexShrink={0}>{t('collab.ownedByMe')}</Badge>
                        </HStack>
                    ))
                )}
            </VStack>
        </ManageDialogFrame>
    );
}
